import {
  trigger,
  animate,
  transition,
  style,
  query,
  group,
} from "@angular/animations";

export const fadeInAnimation = trigger("fadeInAnimation", [
  transition("* <=> *", [
    group([
      query(
        ":enter",
        [
          style({ opacity: 0 }),
          animate("0.2s ease-out", style({ opacity: 1 })),
        ],
        { optional: true },
      ),
      query(":leave", [style({ opacity: 0 })], { optional: true }),
    ]),
  ]),
]);
